import React from "react";
import { DialogContent } from "@material-ui/core";
import FixedPositionDialog from "../../../../../elements/FixedPositionDialog";
import DialogTitleWithCloseIcon from "../../../../../elements/DialogTitleWithCloseIcon";
import MetadataContainer from "./MetadataContainer";
import I18nText from "../../../../../elements/I18nText";

const MetadataDialog = ({ device, onClose }) => {
  return (
    <>
      <FixedPositionDialog open={true} scroll="body">
        <DialogTitleWithCloseIcon onClose={onClose}>
          <I18nText>devices.settings.metadata.sections.baseData</I18nText>
        </DialogTitleWithCloseIcon>
        <DialogContent>
          <MetadataContainer device={device} onClose={onClose} />
        </DialogContent>
      </FixedPositionDialog>
    </>
  );
};

export default MetadataDialog;
